import { samplePoll } from '../Poll';
export const sampleHabitatStatistics = (override) => (Object.assign({ mostVotedOnOpenPoll: { pollId: samplePoll().id, voteCount: 86 } }, override));
